import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import 'the-new-css-reset/css/reset.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@smgl/ui-kit/styles.css';
import '~/app/styles/global.ui.ts';

import { enableMocking } from '~/shared/api/mocks';

import { App } from './App';

const root = document.getElementById('root')!;

enableMocking().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
